/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import type { Options } from '@contentful/rich-text-react-renderer';
import type { Document } from '@contentful/rich-text-types';
import { BLOCKS } from '@contentful/rich-text-types';

import type { EntWebsiteContentColumnLinksFragment } from 'bundles/ent-website/__generated__/contentfulTypes';
import { sharedMarkdownStyles } from 'bundles/ent-website/shared-styles';

type Props = OwnProps & Omit<React.HTMLProps<HTMLDivElement>, keyof OwnProps>;

const styles = {
  richText: sharedMarkdownStyles,
};

export const getRichTextOptions = (links?: EntWebsiteContentColumnLinksFragment): Options => {
  return {
    renderNode: {
      [BLOCKS.EMBEDDED_ENTRY]: (node) => {
        const id = node?.data?.target?.sys?.id;
        const entry = links?.entries?.block?.find((link) => link?.sys?.id === id);

        switch (entry?.__typename) {
          case 'EntWebsiteRichText':
            return (
              <div
                css={css`
                  * {
                    color: ${entry?.color ?? 'var(--cds-color-neutral-primary)'};
                  }
                `}
              >
                {documentToReactComponents(entry?.body?.json)}
              </div>
            );
          default:
            return null;
        }
      },
    },
  };
};

export type OwnProps = {
  content: Document;
  links?: EntWebsiteContentColumnLinksFragment;
};

const EntWebsiteRichText = ({ content, links, ...divElementProps }: Props) => {
  return (
    <div {...divElementProps} css={styles.richText}>
      {documentToReactComponents(content, getRichTextOptions(links))}
    </div>
  );
};

export default EntWebsiteRichText;
